import Bills from "./Bills";
export default function VendorCredits() {
    return <Bills docType="vendor_credit" title="Vendor Credits" kicker="PURCHASES" subtitle="Debit/credit notes against vendors for returns and adjustments." />;
}
